export default {
  nero: {
    100: "#A2A2A2",
    200: "#676767",
    300: "#414141",
    400: "#292929",
    500: "#1A1A1A",
    600: "#0B0B0B",
    700: "#050505",
    800: "#020202",
    900: "#010101",
  },
  nightRider: {
    100: "#484848",
    200: "#414141",
    300: "#3B3B3B",
    400: "#363636",
    500: "#313131",
    600: "#2C2C2C",
    700: "#282828",
    800: "#242424",
    900: "#202020",
  },
  veryLightGrey: {
    100: "#FFFFFF",
    200: "#FFFFFF",
    300: "#F6F6F6",
    400: "#E0E0E0",
    500: "#CCCCCC",
    600: "#B8B8B8",
    700: "#A6A6A6",
    800: "#959595",
    900: "#868686",
  },
  sorbus: {
    100: "#EDAA93",
    200: "#E89375",
    300: "#E47D5A",
    400: "#E06A41",
    500: "#DC582A",
    600: "#CB4D21",
    700: "#B7451E",
    800: "#A53E1B",
    900: "#943818",
  },
  chambray: {
    100: "#89A0C1",
    200: "#7590B7",
    300: "#6381AE",
    400: "#5574A4",
    500: "#4D6995",
    600: "#455F86",
    700: "#3E5679",
    800: "#384D6D",
    900: "#324562",
  },
  amulet: {
    100: "#C6D6C4",
    200: "#B1C7AE",
    300: "#9EB99A",
    400: "#8DAC88",
    500: "#7DA177",
    600: "#6E9567",
    700: "#63865D",
    800: "#597954",
    900: "#506D4C",
  },
}
